import bannersRoute from './banners'
import newsRoute from './news'
import competitionRoute from './competition'
import worksRoute from './works'
import expertsRoute from './experts'
import popupRoute from './popup'
import miniArticleRoute from './mini-article'
import miniBannersRoute from './mini-banners'
import worksHistoryRoute from './works-history'
import expertsLibRoute from './experts-lib'

const routes = [
  competitionRoute,
  bannersRoute,
  newsRoute,
  worksRoute,
  expertsRoute,
  popupRoute,
  miniArticleRoute,
  miniBannersRoute,
  worksHistoryRoute,
  expertsLibRoute
]

export default routes
